// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.formLogin{width:300px;display:block;margin:100px auto 0;padding:20px 40px 40px;border:1px solid #f0f0f0;border-radius:10px}`, "",{"version":3,"sources":["webpack://./src/components/FormLogin/FormLogin.scss"],"names":[],"mappings":"AAAA,WACE,WAAA,CACA,aAAA,CACA,mBAAA,CACA,sBAAA,CACA,wBAAA,CACA,kBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
